import { useEffect, useRef } from 'react';
import { type Control, type FieldValues, useFormState } from 'react-hook-form';

export const useFormDirtyNotify = <T extends FieldValues>(
  control: Control<T>,
  onFormStateChange: (isDirty: boolean) => void,
) => {
  const { isDirty } = useFormState({ control });
  useIsDirtyNotify(isDirty, onFormStateChange);
};

export const useIsDirtyNotify = (isDirty: boolean, onFormStateChange: (isDirty: boolean) => void) => {
  const callbackRef = useRef(onFormStateChange);
  callbackRef.current = onFormStateChange;
  useEffect(() => {
    callbackRef.current(isDirty);
  }, [isDirty]);
};
